import { Permission } from '@vision/ui/interfaces';
import { useAppSelector } from './useAppSelector';

export function usePermissions(): Permission {
  return useAppSelector((state) => state.AuthState.permissions);
}
